import { RouteObject } from 'react-router-dom';
import { appPaths } from 'consts/paths/paths';
import { AdminPasswordUpdatePage } from 'pages';
import { AccountLayout } from 'components/layouts';

export const accountRoutes: RouteObject[] = [
    {
        path: appPaths.app.admin.account.base,
        element: <AccountLayout />,
        children: [
            {
                path: appPaths.app.admin.account['password-update'],
                element: <AdminPasswordUpdatePage />,
            },
        ],
    },
];
